'use strict';

/* Components */
import NavbarComponent from '../components/navbar/navbar.component';
import AccountRequestComponent from '../components/account-request/account-request.component';
import AccountRequestButton from '../components/account-request-button/account-request-button.component';
import html5vfixDirective from '../components/html5vfix/html5vfix.directive';
import ContactFormComponent from '../components/contact-form/contact-form.component';

import PostInfoComponent from '../components/post-info/post-info.component';
import PostSummaryComponent from '../components/post-summary/PostSummary.component';

import NewsFeedComponent from '../components/news-feed/news-feed.component';

import VideoPlayerComponent from '../components/video-player/video-player.component';

import 'videogular/dist/videogular/videogular.min';
import 'videogular/dist/controls/vg-controls.min';
import 'videogular-themes-default/videogular.min.css';

import IFrameWidgetComponent from '../components/sidebar/iframe-widget/iframe-widget.component';
import PayFeesOnlineWidgetComponent from '../components/sidebar/pay-fees-online-widget/pay-fees-online-widget.component';
import PiperExpectedTodayWidgetComponent from '../components/sidebar/piper-expected-today-widget/piper-expected-today-widget.component';
import PiperUpcomingGuestsWidgetComponent from '../components/sidebar/piper-upcoming-guests-widget/piper-upcoming-guests-widget.component';
import CalendarWidgetComponent from '../components/sidebar/calendar-widget/calendar-widget.component';
import ContactWidgetComponent from '../components/sidebar/contact-widget/contact-widget.component';
import DocumentsWidgetComponent from '../components/sidebar/documents-widget/documents-widget.component';
import BulletinsWidgetComponent from '../components/sidebar/bulletins-widget/bulletins-widget.component';
import GalleriesWidgetComponent from '../components/sidebar/galleries-widget/galleries-widget.component';
import NewsWidgetComponent from '../components/sidebar/news-widget/news-widget.component';

import SectionHeaderComponent from '../components/section-header/section-header.component';
import WeatherWidgetComponent from '../components/sidebar/weather-widget/weather-widget.component';

import usPhoneFilter from '../components/us-phone-filter/us-phone.filter';

import menuEntryEditComponent from '../components/menu-entry-edit/menu-entry-edit.component';

/* Module */
export default angular.module('conduuApp.components', [NavbarComponent, AccountRequestComponent, AccountRequestButton,
  html5vfixDirective, ContactFormComponent, PostInfoComponent, PostSummaryComponent, NewsFeedComponent, VideoPlayerComponent,
  "com.2fdevs.videogular", "com.2fdevs.videogular.plugins.controls", IFrameWidgetComponent, PayFeesOnlineWidgetComponent,
  PiperExpectedTodayWidgetComponent, PiperUpcomingGuestsWidgetComponent, CalendarWidgetComponent, ContactWidgetComponent,
  DocumentsWidgetComponent, BulletinsWidgetComponent, GalleriesWidgetComponent, NewsWidgetComponent, SectionHeaderComponent,
  WeatherWidgetComponent, menuEntryEditComponent, usPhoneFilter])
.name;



// WEBPACK FOOTER //
// ./client/components/index.js